export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/CL-abfba27a20ad1109148b9252e9fae9b2.png";